import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../components/Icon';

class StarRating extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    maxValue: PropTypes.number,
    value: PropTypes.number,
  };

  static defaultProps = {
    className: '',
    maxValue: 5,
    value: 0,
  };

  static renderIcon(index, value) {
    let star = 'IconStar';

    if (value < index) {
      star = 'IconEmptyStar';
    }

    if (Math.ceil(value) === index && value % 1 !== 0) {
      star = 'IconHalfStar';
    }

    return (
      <Icon
        type={star}
        key={index}
        className="resume-rating"
        title={`Rating: ${value}`}
        data-value={index}
        height={16}
        width={16}
      />
    );
  }

  renderStars() {
    const { value, maxValue } = this.props;

    // populate stars
    const starNodes = [];
    for (let starIndex = 1; starIndex <= maxValue; starIndex += 1) {
      const starNode = StarRating.renderIcon(starIndex, value);
      starNodes.push(starNode);
    }

    return starNodes;
  }

  render() {
    const { className, value } = this.props;

    return (
      <div className={className} title={`Rating: ${value}`} data-rating={value}>
        {this.renderStars()}
      </div>
    );
  }
}

export default StarRating;



// WEBPACK FOOTER //
// ./src/pages/resume/_StarRating.js